import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit {

  isLoggedIn: boolean;

  title = [
    '_PRIVACY.TITLE_1',
    '_PRIVACY.TITLE_2'
  ];

  content = '_PRIVACY.CONTENT';

  constructor(private authService: AuthService) {
    this.authService.currentUser.subscribe(currentUser => this.isLoggedIn = !!(currentUser) );
  }

  ngOnInit() {}

}
